import logger from 'client-logger';

/**
 * Receives a GraphQL error object and returns a formatted object with all properties we typically care about
 *
 * @param {Object} error -- this is the graphql error object
 * @return {Object} -- Formatted error object
 */
export default function formatGraphQlError(error) {
	// Only return the error if the calling code can use it
	const formatted = {};

	// Add the code
	try {
		formatted.code = error.graphQLErrors[0].extensions.code;
	} catch (e) {
		// Well, I guess we don't have a code?
		logger.error({ error }, 'Received GraphQL error array with no entry or no extensions');
	}

	// Add the message
	try {
		formatted.message = error.graphQLErrors[0].message;
	} catch (e) {
		// Well, I guess we don't have a code?
		logger.error({ error }, 'Received GraphQL error array with no entry');
	}

	// Add any additional props
	try {
		formatted.props = error.graphQLErrors[0].extensions.exception;

		if (formatted.props) {
			// Remove the stack trace - definitely don't need that
			delete formatted.props.stacktrace;
		}
	} catch (e) {
		// Well, I guess we don't have a code?
		logger.error({ error }, 'Received GraphQL error array with no entry or no extensions');
	}

	return formatted;
}
